import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';

import { SearchService } from '../../services/search.service';
import { Product } from '../../models/product.model';
import { isEmptyArray } from '../../shared/utils';

const MIN_SYMBOLS_TO_SEARCH = 3;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SearchComponent implements OnInit {
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  searchText = '';
  foundProducts: Product[] = [];
  totalCount = 0;
  isSearching = false;
  searchPerformed = false;

  constructor(
    protected searchService: SearchService,
    private elementRef: ElementRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.setFocus();
    // this.searchText = this.searchService.globalTerm || '';
  }

  selectSearchOption(product: Product) {
    this.router.navigate([product.productURL]);
  }

  showHighlights(label: string): string {
    return this.searchService.highlight(label);
  }

  search() {
    // if (!this.searchText) {
    //     // this.searchService.clearSearchResults();
    // }

    if (this.searchText.length < MIN_SYMBOLS_TO_SEARCH) {
      return;
    }

    this.foundProducts = [];
    this.totalCount = 0;
    this.isSearching = true;
    this.searchPerformed = false;
    this.searchService
      .productsSearch({ localSearch: true })
      .pipe()
      .subscribe((result) => {
        if (!isEmptyArray(result.products)) {
          result.products.forEach((p) => {
            if (p instanceof Product) {
              this.foundProducts.push(p);
            }
          });

          this.totalCount = result.count;
        }
        this.isSearching = false;
        this.searchPerformed = true;
      });
  }

  get foundProductsCount(): number {
    return this.foundProducts.length;
  }

  selectViewAll() {
    this.searchService.setOnUpdateSearchText(true);
    this.searchService.globalTerm = this.searchText;
    this.searchService.setFoundProducts(this.foundProducts);
    this.searchService.totalProducts = this.totalCount;
    this.router.navigate(['/search-results']);
  }

  clearSearch() {
    this.searchText = '';
    this.foundProducts = [];
    // this.searchService.clearSearchResults();
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.search();
    }

    if (e.key === 'Escape') {
      this.clearSearch();
    }
  }

  private setFocus() {
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 500);
  }

  get isMoreDataAvailable(): boolean {
    return this.foundProductsCount < this.totalCount;
  }
}
